function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, t) {
  for (var n = 0; n < t.length; n++) {
    var i = t[n];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}

function _createClass(e, t, n) {
  return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
}

function _defineProperty(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && _setPrototypeOf(e, t);
}

function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? _assertThisInitialized(e) : t;
}

function debounced(e, t) {
  var n;
  return function () {
    for (var i = arguments.length, o = new Array(i), r = 0; r < i; r++) {
      o[r] = arguments[r];
    }

    n && clearTimeout(n), n = setTimeout(function () {
      e.apply(void 0, o), n = null;
    }, t);
  };
}

function throttled(e, t) {
  var n = 0;
  return function () {
    var i = new Date().getTime();
    if (!(i - n < t)) return n = i, e.apply(void 0, arguments);
  };
}

import { Component } from "react";
import PropTypes from "prop-types";

var IS_BROWSER = "object" === ("undefined" == typeof window ? "undefined" : "undefined" == typeof window ? "undefined" : _typeof(window)),
    DEFAULT_ELEMENT = IS_BROWSER ? document : {},
    DEFAULT_EVENTS = ["mousemove", "keydown", "wheel", "DOMMouseScroll", "mouseWheel", "mousedown", "touchstart", "touchmove", "MSPointerDown", "MSPointerMove"],
    IdleTimer = function (e) {
  function t(e) {
    var n;
    if (_classCallCheck(this, t), n = _possibleConstructorReturn(this, _getPrototypeOf(t).call(this, e)), _defineProperty(_assertThisInitialized(n), "state", {
      idle: !1,
      oldDate: +new Date(),
      lastActive: +new Date(),
      remaining: null,
      pageX: null,
      pageY: null
    }), _defineProperty(_assertThisInitialized(n), "tId", null), _defineProperty(_assertThisInitialized(n), "_handleEvent", function (e) {
      var t = n.state,
          i = t.remaining,
          o = t.pageX,
          r = t.pageY,
          s = t.idle,
          a = n.props,
          u = a.timeout,
          l = a.onAction,
          p = a.debounce,
          d = a.throttle,
          c = a.stopOnIdle;

      if (p > 0 ? n.debouncedAction(e) : d > 0 ? n.throttledAction(e) : l(e), !i) {
        if ("mousemove" === e.type) {
          if (e.pageX === o && e.pageY === r) return;
          if (void 0 === e.pageX && void 0 === e.pageY) return;
          if (n.getElapsedTime() < 200) return;
        }

        clearTimeout(n.tId), n.tId = null, s && !c && n.toggleIdleState(e), n.setState({
          lastActive: +new Date(),
          pageX: e.pageX,
          pageY: e.pageY
        }), s ? c || (n.tId = setTimeout(n.toggleIdleState, u)) : n.tId = setTimeout(n.toggleIdleState, u);
      }
    }), e.debounce > 0 && e.throttle > 0) throw new Error("onAction can either be throttled or debounced (not both)");
    return e.debounce > 0 && (n.debouncedAction = debounced(e.onAction, e.debounce)), e.throttle > 0 && (n.throttledAction = throttled(e.onAction, e.throttle)), e.startOnMount || (n.state.idle = !0), n.toggleIdleState = n._toggleIdleState.bind(_assertThisInitialized(n)), n.reset = n.reset.bind(_assertThisInitialized(n)), n.pause = n.pause.bind(_assertThisInitialized(n)), n.resume = n.resume.bind(_assertThisInitialized(n)), n.getRemainingTime = n.getRemainingTime.bind(_assertThisInitialized(n)), n.getElapsedTime = n.getElapsedTime.bind(_assertThisInitialized(n)), n.getLastActiveTime = n.getLastActiveTime.bind(_assertThisInitialized(n)), n.isIdle = n._isIdle.bind(_assertThisInitialized(n)), n;
  }

  return _inherits(t, e), _createClass(t, [{
    key: "componentDidMount",
    value: function value() {
      this._bindEvents(), this.props.startOnMount && this.reset();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      e.debounce !== this.props.debounce && (this.debouncedAction = debounced(this.props.onAction, this.props.debounce)), e.throttle !== this.props.throttle && (this.throttledAction = throttled(this.props.onAction, this.props.throttle));
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      clearTimeout(this.tId), this._unbindEvents();
    }
  }, {
    key: "render",
    value: function value() {
      return this.props.children || null;
    }
  }, {
    key: "_bindEvents",
    value: function value() {
      var e = this;

      if (IS_BROWSER) {
        var t = this.state.eventsBound,
            n = this.props,
            i = n.element,
            o = n.events,
            r = n.passive,
            s = n.capture;
        t || (o.forEach(function (t) {
          i.addEventListener(t, e._handleEvent, {
            capture: s,
            passive: r
          });
        }), this.setState({
          eventsBound: !0
        }));
      }
    }
  }, {
    key: "_unbindEvents",
    value: function value() {
      var e = this;

      if (IS_BROWSER) {
        var t = this.props,
            n = t.element,
            i = t.events,
            o = t.passive,
            r = t.capture;
        this.state.eventsBound && (i.forEach(function (t) {
          n.removeEventListener(t, e._handleEvent, {
            capture: r,
            passive: o
          });
        }), this.setState({
          eventsBound: !1
        }));
      }
    }
  }, {
    key: "_toggleIdleState",
    value: function value(e) {
      var t = this,
          n = this.state.idle,
          i = this.props,
          o = i.onActive,
          r = i.onIdle,
          s = i.stopOnIdle;
      this.setState({
        idle: !n
      }, function () {
        n ? s || (t._bindEvents(), o(e)) : (s && (clearTimeout(t.tId), t.tId = null, t._unbindEvents()), r(e));
      });
    }
  }, {
    key: "reset",
    value: function value() {
      clearTimeout(this.tId), this.tId = null, this._bindEvents(), this.setState({
        idle: !1,
        oldDate: +new Date(),
        lastActive: +new Date(),
        remaining: null
      });
      var e = this.props.timeout;
      this.tId = setTimeout(this.toggleIdleState, e);
    }
  }, {
    key: "pause",
    value: function value() {
      null === this.state.remaining && (this._unbindEvents(), clearTimeout(this.tId), this.tId = null, this.setState({
        remaining: this.getRemainingTime()
      }));
    }
  }, {
    key: "resume",
    value: function value() {
      var e = this.state,
          t = e.remaining,
          n = e.idle;
      null !== t && (this._bindEvents(), n || (this.setState({
        remaining: null,
        lastActive: +new Date()
      }), this.tId = setTimeout(this.toggleIdleState, t)));
    }
  }, {
    key: "getRemainingTime",
    value: function value() {
      var e = this.state,
          t = e.remaining,
          n = e.lastActive,
          i = this.props.timeout;
      if (null !== t) return t < 0 ? 0 : t;
      var o = i - (+new Date() - n);
      return o < 0 ? 0 : o;
    }
  }, {
    key: "getElapsedTime",
    value: function value() {
      var e = this.state.oldDate;
      return +new Date() - e;
    }
  }, {
    key: "getLastActiveTime",
    value: function value() {
      return this.state.lastActive;
    }
  }, {
    key: "_isIdle",
    value: function value() {
      return this.state.idle;
    }
  }]), t;
}(Component);

_defineProperty(IdleTimer, "propTypes", {
  timeout: PropTypes.number,
  events: PropTypes.arrayOf(PropTypes.string),
  onIdle: PropTypes.func,
  onActive: PropTypes.func,
  onAction: PropTypes.func,
  debounce: PropTypes.number,
  throttle: PropTypes.number,
  element: PropTypes.oneOfType([PropTypes.object, PropTypes.element]),
  startOnMount: PropTypes.bool,
  stopOnIdle: PropTypes.bool,
  passive: PropTypes.bool,
  capture: PropTypes.bool
}), _defineProperty(IdleTimer, "defaultProps", {
  timeout: 12e5,
  element: DEFAULT_ELEMENT,
  events: DEFAULT_EVENTS,
  onIdle: function onIdle() {},
  onActive: function onActive() {},
  onAction: function onAction() {},
  debounce: 0,
  throttle: 0,
  startOnMount: !0,
  stopOnIdle: !1,
  capture: !0,
  passive: !0
});
export default IdleTimer;